import { jsxs as d, jsx as h } from "react/jsx-runtime";
import { E as a, S as V } from "./icons.types-0722eef5.js";
function g({ title: c, titleId: n, size: l, width: o, height: s, extended: r = !1, ...e }) {
  const i = r ? a : V, v = l ? i[l] : o || i[r ? "s" : "l"], t = l ? i[l] : s || i[r ? "s" : "l"];
  return /* @__PURE__ */ d(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: v,
      height: t,
      "aria-labelledby": n,
      ...e,
      children: [
        c ? /* @__PURE__ */ h("title", { id: n, children: c }) : null,
        /* @__PURE__ */ h("g", { clipPath: "url(#PDF_svg__a)", children: /* @__PURE__ */ h(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M9 60h45V37.502H9V60ZM43.928 1.5l19.716 19.712V70.5H14.355V63h4.928v2.567h39.433V26.145H39V6.428H19.283V34.5h-4.928v-33h29.573ZM51 40.5V57H12V40.5h39Zm-28.842 2.385h-4.995V54h1.485v-4.02h3.465c2.88 0 3.975-1.365 3.975-3.66 0-2.28-1.125-3.435-3.93-3.435Zm9.448 0h-3.72V54h3.555c4.245 0 6-1.32 6-5.565 0-4.32-1.605-5.55-5.835-5.55Zm15.013 0h-7.395V54h1.515v-4.875h5.745v-1.44H40.74V44.34h5.88v-1.455Zm-14.998 1.44c3.435 0 4.29 1.005 4.29 4.11 0 3.06-1.02 4.17-4.395 4.17H29.4v-8.28h2.22Zm-9.493-.03c1.65 0 2.445.465 2.445 2.1 0 1.605-.825 2.175-2.415 2.175h-3.51v-4.275h3.48Zm21.8-35.826v12.743h12.747L43.928 8.469Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ h("defs", { children: /* @__PURE__ */ h("clipPath", { id: "PDF_svg__a", children: /* @__PURE__ */ h(
          "path",
          {
            fill: "currentColor",
            d: "M0 0h72v72H0z"
          }
        ) }) })
      ]
    }
  );
}
export {
  g as Pdf
};
